import Vue from "vue";

export default {
  model: {
    prop: "inputModel",
    event: "change",
  },
  data: () => {
    return {
      displayModel: null,
    };
  },
  mounted() {
    if (this.multiple) {
      Vue.set(this, "displayModel", []);
    } else {
      Vue.set(this, "displayModel", this.inputModel);
    }
    // this.displayModel = this.inputModel;
  },
  created() {
    if (this.multiple) {
      Vue.set(this, "displayModel", []);
    } else {
      Vue.set(this, "displayModel", null);
    }
  },
  watch: {
    displayModel: {
      handler() {
        this.$emit("change", this.displayModel);
      },
    },
    inputModel: {
      handler() {
        this.displayModel = this.inputModel;
      },
    },
    selected: {
      handler(val) {
        this.inputModel = val;
      },
    },
  },
};
